import React from "react";
import { Helmet } from "react-helmet";
import About from "../components/About/About";

const AboutPage = () => {
  return (
    <div>
      {/* React Helmet for SEO */}
      <Helmet>
        <title>Om Oss | Dolcehem - Din Pålitliga Onlinebutik</title>
        <meta
          name="description"
          content="Lär känna oss på Dolcehem. Vi strävar efter att erbjuda bästa möjliga produkter och kundservice. Upptäck vår historia och våra värderingar."
        />
        <meta
          name="keywords"
          content="Dolcehem, Om oss, företagshistoria, värderingar, kundservice, onlinebutik"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Om Oss | Dolcehem" />
        <meta
          property="og:description"
          content="Läs mer om Dolcehem, vår historia och våra mål. Vi sätter alltid kunden i fokus och strävar efter att leverera högsta kvalitet."
        />
        <meta property="og:image" content="/path/to/og-image.jpg" />
        <meta property="og:url" content="https://dolcehem.se/about" />
        <meta property="og:type" content="website" />
      </Helmet>

      <About />
    </div>
  );
};

export default AboutPage;
